import { useEffect } from 'react';

export default function ThemeInitializer() {
    useEffect(() => {
        // Set dark mode as default if no theme is set
        if (!localStorage.getItem('darkMode')) {
            localStorage.setItem('darkMode', 'true');
            document.documentElement.classList.add('dark');
        }
    }, []);

    return null;
} 